﻿import $ from 'jquery';
import { ErrorPopover } from "./errorpopover";
import { FormValidation, IValidationHandler } from "./formvalidation"

export class FieldValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    if ($error.data('error-handled') == true)
      return true;

    let errorMessage = $error.html();
    
    let targetId = $error.data('for');
    let $context = this.resolveContext($error);
    let $targetInput = $context.find('#' + targetId);

    if ($targetInput.length == 0)
      return false;

    $targetInput.data('error-handled', true);
    $error.remove();

    new ErrorPopover().append($targetInput, targetId, errorMessage);

    return true;
  }

  private resolveContext($error: JQuery) {
    let $form = $error.closest('form');

    return $form.length > 0 ? $form
                            : $(document);
  }
}